export const getQueryField = (
  query: { [key: string]: string },
  field: string,
  toUpperCase?: boolean,
): string => {
  const value = query[field]?.trim() ?? '';
  return toUpperCase ? value.toUpperCase() : value;
};
